export let FlightType = /*#__PURE__*/function (FlightType) {
  FlightType["ROUND_TRIP"] = "ROUND_TRIP";
  FlightType["ONE_WAY"] = "ONE_WAY";
  FlightType["MULTI_DESTINATION"] = "MULTI_DESTINATION";
  return FlightType;
}({});
export let CabinClass = /*#__PURE__*/function (CabinClass) {
  CabinClass["ECONOMY"] = "ECONOMY";
  CabinClass["PREMIUM_ECONOMY"] = "PREMIUM_ECONOMY";
  CabinClass["BUSINESS"] = "BUSINESS";
  CabinClass["FIRST_CLASS"] = "FIRST_CLASS";
  return CabinClass;
}({});